import Menu from '@/assets/images/menu.svg'
import IconButton from '@/components/UI/buttons/IconButton'
import { DrawerActions, useNavigation } from '@react-navigation/native'
import { FC } from 'react'

const buttonWidth = 40
const menuIconWidth = 24
const menuIconMarginLeft = 16
const buttonMarginLeft = menuIconMarginLeft - (buttonWidth - menuIconWidth) / 2

const CompactMainHeaderMenuButton: FC = () => {
    const navigation = useNavigation()

    const handlePress = () => {
        navigation.dispatch(DrawerActions.openDrawer())
    }

    return (
        <IconButton
            size={buttonWidth}
            Icon={Menu}
            onPress={handlePress}
            style={{ marginLeft: buttonMarginLeft }}
        />
    )
}

export default CompactMainHeaderMenuButton
